import { gql } from "@apollo/client";

export const GET_PDF_VISITA = gql`
    query GetImprimirVisitaDetalle($idVisita: Int!) {
        imprimirVisitaDetalle(idVisita: $idVisita)
    }
`;